import { render, staticRenderFns } from "./AccountSettingsPassword.vue?vue&type=template&id=c0227828"
import script from "./AccountSettingsPassword.vue?vue&type=script&lang=js"
export * from "./AccountSettingsPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports